export interface DwellSessionState {
	id: string | null;
	startedAt: number | null;
}

export function createDwellSessionState(): DwellSessionState {
	return { id: null, startedAt: null };
}

export function startDwellSession(state: DwellSessionState, id: string, timestamp: number): void {
	if (state.id !== null) {
		return;
	}
	state.id = id;
	state.startedAt = timestamp;
}

export function endDwellSession(state: DwellSessionState): void {
	state.id = null;
	state.startedAt = null;
}

export function isDwellSessionActive(state: DwellSessionState): boolean {
	return state.id !== null;
}

export function getDwellSessionId(state: DwellSessionState): string | null {
	return state.id;
}
